/**
 * 微信JS-SDK工具类
 * 包含微信JS-SDK相关的所有工具方法
 */

// 使用浏览器端可用的 crypto-js 实现 SHA1，避免打包到 Node 的 crypto
import CryptoJS from 'crypto-js'

// 简单的SHA1实现，用于浏览器环境
const sha1 = (str) => {
  try {
    return CryptoJS.SHA1(str).toString()
  } catch (e) {
    // 兜底：纯浏览器 JS 的 SHA1 实现
  }
  
  // 浏览器环境的SHA1实现
  const rotateLeft = (n, s) => (n << s) | (n >>> (32 - s))
  const cvtHex = (val) => {
    let str = ''
    for (let i = 7; i >= 0; i--) {
      const v = (val >>> (i * 4)) & 0x0f
      str += v.toString(16)
    }
    return str
  }
  
  let blockstart
  let i
  const W = new Array(80)
  let H0 = 0x67452301
  let H1 = 0xEFCDAB89
  let H2 = 0x98BADCFE
  let H3 = 0x10325476
  let H4 = 0xC3D2E1F0
  let A, B, C, D, E
  let temp
  
  str = str.replace(/\r\n/g, '\n')
  let utftext = ''
  
  for (let n = 0; n < str.length; n++) {
    const c = str.charCodeAt(n)
    if (c < 128) {
      utftext += String.fromCharCode(c)
    } else if ((c > 127) && (c < 2048)) {
      utftext += String.fromCharCode((c >> 6) | 192)
      utftext += String.fromCharCode((c & 63) | 128)
    } else {
      utftext += String.fromCharCode((c >> 12) | 224)
      utftext += String.fromCharCode(((c >> 6) & 63) | 128)
      utftext += String.fromCharCode((c & 63) | 128)
    }
  }
  
  const msg = utftext
  const msgLength = msg.length
  const wordArray = []
  
  for (let i = 0; i < msgLength - 3; i += 4) {
    const j = msg.charCodeAt(i) << 24 | msg.charCodeAt(i + 1) << 16 | msg.charCodeAt(i + 2) << 8 | msg.charCodeAt(i + 3)
    wordArray.push(j)
  }
  
  switch (msgLength % 4) {
    case 0:
      i = 0x080000000
      break
    case 1:
      i = msg.charCodeAt(msgLength - 1) << 24 | 0x0800000
      break
    case 2:
      i = msg.charCodeAt(msgLength - 2) << 24 | msg.charCodeAt(msgLength - 1) << 16 | 0x08000
      break
    case 3:
      i = msg.charCodeAt(msgLength - 3) << 24 | msg.charCodeAt(msgLength - 2) << 16 | msg.charCodeAt(msgLength - 1) << 8 | 0x80
      break
  }
  
  wordArray.push(i)
  
  while ((wordArray.length % 16) !== 14) wordArray.push(0)
  
  wordArray.push(msgLength >>> 29)
  wordArray.push((msgLength << 3) & 0x0ffffffff)
  
  for (blockstart = 0; blockstart < wordArray.length; blockstart += 16) {
    for (i = 0; i < 16; i++) W[i] = wordArray[blockstart + i]
    for (i = 16; i <= 79; i++) W[i] = rotateLeft(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1)
    
    A = H0
    B = H1
    C = H2
    D = H3
    E = H4
    
    for (i = 0; i <= 19; i++) {
      temp = (rotateLeft(A, 5) + ((B & C) | (~B & D)) + E + W[i] + 0x5A827999) & 0x0ffffffff
      E = D
      D = C
      C = rotateLeft(B, 30)
      B = A
      A = temp
    }
    
    for (i = 20; i <= 39; i++) {
      temp = (rotateLeft(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ED9EBA1) & 0x0ffffffff
      E = D
      D = C
      C = rotateLeft(B, 30)
      B = A
      A = temp
    }
    
    for (i = 40; i <= 59; i++) {
      temp = (rotateLeft(A, 5) + ((B & C) | (B & D) | (C & D)) + E + W[i] + 0x8F1BBCDC) & 0x0ffffffff
      E = D
      D = C
      C = rotateLeft(B, 30)
      B = A
      A = temp
    }
    
    for (i = 60; i <= 79; i++) {
      temp = (rotateLeft(A, 5) + (B ^ C ^ D) + E + W[i] + 0xCA62C1D6) & 0x0ffffffff
      E = D
      D = C
      C = rotateLeft(B, 30)
      B = A
      A = temp
    }
    
    H0 = (H0 + A) & 0x0ffffffff
    H1 = (H1 + B) & 0x0ffffffff
    H2 = (H2 + C) & 0x0ffffffff
    H3 = (H3 + D) & 0x0ffffffff
    H4 = (H4 + E) & 0x0ffffffff
  }
  
  temp = cvtHex(H0) + cvtHex(H1) + cvtHex(H2) + cvtHex(H3) + cvtHex(H4)
  return temp.toLowerCase()
}

/**
 * 生成随机字符串
 * @param {number} length 字符串长度，默认15
 * @returns {string} 随机字符串
 */
export const generateNonceStr = (length = 15) => {
  return Math.random().toString(36).substr(2, length)
}

/**
 * 生成当前时间戳
 * @returns {number} 时间戳（秒）
 */
export const generateTimestamp = () => {
  return Math.floor(Date.now() / 1000)
}

/**
 * 获取当前页面URL（不包含hash和search参数）
 * @returns {string} 当前页面URL
 */
export const getCurrentUrl = () => {
  if (typeof window !== 'undefined') {
    return window.location.href.split('#')[0].split('?')[0]
  }
  return ''
}

/**
 * 生成微信JS-SDK签名
 * @param {string} jsapi_ticket jsapi_ticket
 * @param {string} nonceStr 随机字符串
 * @param {number} timestamp 时间戳
 * @param {string} url 当前页面URL
 * @returns {string} 签名
 */
export const generateWeChatSignature = (jsapi_ticket, nonceStr, timestamp, url) => {
  // 微信JS-SDK签名算法
  // 1. 对所有待签名参数按照字段名的ASCII码从小到大排序（字典序）
  // 2. 使用URL键值对的格式（即key1=value1&key2=value2…）拼接成字符串
  // 3. 对拼接后的字符串进行sha1加密，得到签名
  
  // 参数排序
  const params = {
    jsapi_ticket: jsapi_ticket,
    noncestr: nonceStr,
    timestamp: timestamp,
    url: url
  }
  
  // 按key排序并拼接
  const sortedKeys = Object.keys(params).sort()
  const string1 = sortedKeys.map(key => `${key}=${params[key]}`).join('&')
  
  // 生成sha1签名
  const signature = sha1(string1)
  
  return signature
}

/**
 * 获取jsapi_ticket的辅助方法（需要后端支持）
 * @param {string} appId 微信公众号AppID
 * @param {string} appSecret 微信公众号AppSecret
 * @returns {Promise<string|null>} jsapi_ticket或null
 */
export const getJsapiTicket = async (appId, appSecret) => {
  try {
    // 这里需要调用您的后端API来获取jsapi_ticket
    // 因为jsapi_ticket需要通过access_token获取，而access_token需要appSecret
    // 为了安全，建议在后端获取并缓存
    console.warn('请配置正确的jsapi_ticket，或通过后端API获取', { 
      appId, 
      appSecret: appSecret ? '***' : 'undefined' 
    })
    return null
  } catch (error) {
    console.error('获取jsapi_ticket失败:', error)
    return null
  }
}

 

/**
 * 生成微信JS-SDK配置对象（用于wx.config）
 * @param {Object} config 配置对象
 * @returns {Object} 微信JS-SDK配置对象
 */
export const buildWeChatJSSDKConfig = (config) => {
  const isDev = process.env.NODE_ENV === 'development'
  const envConfig = isDev ? config.WECHAT_JS_SDK.DEV_CONFIG : config.WECHAT_JS_SDK.PROD_CONFIG
  
  // 验证配置中的必需参数
  const requiredFields = ['APP_ID', 'JSAPI_TICKET']
  const missingFields = requiredFields.filter(field => !envConfig[field])
  
  if (missingFields.length > 0) {
    throw new Error(`微信JS-SDK配置缺少必需参数: ${missingFields.join(', ')}`)
  }
  
  // 动态生成时间戳和随机字符串
  const timestamp = envConfig.TIMESTAMP || generateTimestamp()
  const nonceStr = envConfig.NONCE_STR || generateNonceStr()
  
  // 获取当前页面URL
  const url = getCurrentUrl()
  
  // 生成签名
  let signature
  if (envConfig.SIGNATURE && envConfig.SIGNATURE !== 'dev_signature' && envConfig.SIGNATURE !== 'prod_signature') {
    // 如果配置了自定义签名，使用配置的签名
    signature = envConfig.SIGNATURE
  } else {
    // 自动生成签名
    try {
      signature = generateWeChatSignature(envConfig.JSAPI_TICKET, nonceStr, timestamp, url)
    } catch (error) {
      console.warn('自动生成签名失败，使用默认签名:', error.message)
      signature = 'default_signature'
    }
  }
  
  return {
    beta: config.WECHAT_JS_SDK.BETA,
    debug: envConfig.DEBUG,
    jsApiList: config.WECHAT_JS_SDK.JS_API_LIST,
    timeout: envConfig.TIMEOUT,
    appId: envConfig.APP_ID,
    timestamp: timestamp,
    nonceStr: nonceStr,
    signature: signature
  }
}

// 导出所有方法
export default {
  generateNonceStr,
  generateTimestamp,
  getCurrentUrl,
  generateWeChatSignature,
  getJsapiTicket,
  buildWeChatJSSDKConfig
}
